import type { LucideIcon, LucideProps } from 'lucide-react';

type AppIconProps = Omit<LucideProps, 'ref'> & {
  icon: LucideIcon;
};

export default function AppIcon({
  icon: Icon,
  size = 24,
  strokeWidth = 1.75,
  className,
  ...rest
}: AppIconProps) {
  return (
    <Icon
      size={size}
      strokeWidth={strokeWidth}
      className={className}
      aria-hidden={rest['aria-label'] ? undefined : true}
      {...rest}
    />
  );
}
